/* eslint-disable no-underscore-dangle */
import { error } from '../Log'

const listrakOrderTracking = (
  user: {
    email: string
    firstName: string
    lastName: string
  },
  order: {
    orderId: number | string
  },
  lineItems: Array<{
    sku: string
    quantity: number
    salePrice: number
  }>,
  itemsSubtotal: number,
  shippingCost: number,
  taxTotal: number,
  grandTotal: number,
) => {
  try {
    // eslint-disable-next-line no-undef
    const listrak = window._ltk
    if (listrak && !!order?.orderId && !!user?.email) {
      listrak.Order.SetCustomer(user.email, user.firstName, user.lastName)
      listrak.Order.OrderNumber = order.orderId
      listrak.Order.ItemTotal = itemsSubtotal
      listrak.Order.ShippingTotal = shippingCost
      listrak.Order.TaxTotal = taxTotal
      listrak.Order.OrderTotal = grandTotal

      lineItems.forEach((i) => listrak.Order.AddItem(i.sku, i.quantity, i.salePrice))

      listrak.Order.Submit()
    }
  } catch (e) {
    error('Failed listrakOrderTracking', e)
  }
}

export default listrakOrderTracking
